import swaggerClient from "../remote-client";

export default class CoverageServiceImpl {
  getCeilingsWithYear(year) {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient.then(client => {
        return client.apis.MemberProfile.getCeilingsWithYear(
          { year },
          swaggerClient.buildRequest(),
          {}
        )
          .then(res => resolve(res.body.ceilingList))
          .catch(error => reject(error));
      });
    });
  }

  /**
   *
   * @param {*} payload {fromDate,toDate}
   */
  getCoverages(payload) {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient.then(client => {
        return client.apis.MemberProfile.getCoveragesWithMemberFiscalCode(
          payload,
          swaggerClient.buildRequest(),
          {}
        )
          .then(res => resolve(res.body))
          .catch(error => reject(error));
      });
    });
  }

  getServiceBookingInfo(payload) {
    return new Promise((resolve, reject) => {
      swaggerClient.memberSwaggerClient.then(client => {
        return client.apis.Appointment.getBookingInfoServiceWithIdMemberWithMemberFiscalCode(
          payload,
          swaggerClient.buildRequest(),
          {}
        )
          .then(res => resolve(res.body.bookingInfo))
          .catch(error => reject(error));
      });
    });
  }
}
